import { weekOfYear } from '../deprecated';
import { clamp } from '../math';
export var compareYear = function compareYear(a, b) {
  return a.getFullYear() - b.getFullYear();
};
export var compareMonth = function compareMonth(a, b) {
  return compareYear(a, b) || a.getMonth() - b.getMonth();
};
export var compareDate = function compareDate(a, b) {
  return compareMonth(a, b) || a.getDate() - b.getDate();
};
export var compareHours = function compareHours(a, b) {
  return compareDate(a, b) || a.getHours() - b.getHours();
};
export var compareMinutes = function compareMinutes(a, b) {
  return compareHours(a, b) || a.getMinutes() - b.getMinutes();
};
export var compareSeconds = function compareSeconds(a, b) {
  return compareMinutes(a, b) || a.getSeconds() - b.getSeconds();
};
export var compareTime = function compareTime(a, b) {
  return a.getTime() - b.getTime();
};
export var compareMilliseconds = compareTime;
var dayOfWeekComparerMap = Array.from({
  length: 7
}, function (_, startDay) {
  var resolveDay = function resolveDay(day) {
    var result = day - startDay;

    if (result < 0) {
      return 7 - result;
    }

    return result;
  };

  return startDay ? function (a, b) {
    return resolveDay(a.getDay()) - resolveDay(b.getDay());
  } : function (a, b) {
    return a.getDay() - b.getDay();
  };
});
export function createCompareDayOfWeek() {
  var startDay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var offset = Math.floor(clamp(startDay, 0, 6));
  return dayOfWeekComparerMap[offset];
}
export var compareDayOfWeek = createCompareDayOfWeek(0);
var weekOfYearComparerMap = Array.from({
  length: 7
}, function (_, startDay) {
  return function (a, b) {
    return weekOfYear(a, startDay, 1970) - weekOfYear(b, startDay, 1970);
  };
});
export function createCompareWeekOfYear() {
  var startDay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var offset = Math.floor(clamp(startDay, 0, 6));
  return weekOfYearComparerMap[offset];
}
export var compareWeekOfYear = createCompareDayOfWeek(0);
export function compareDateTime(type, a, b) {
  var startDay = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  switch (type) {
    case 'year':
      return compareYear(a, b);

    case 'month':
      return compareMonth(a, b);

    case 'date':
      return compareDate(a, b);

    case 'hours':
      return compareHours(a, b);

    case 'minutes':
      return compareMinutes(a, b);

    case 'seconds':
      return compareSeconds(a, b);

    case 'day':
      return createCompareDayOfWeek(startDay)(a, b);

    case 'week':
      return createCompareWeekOfYear(startDay)(a, b);

    default:
      return compareTime(a, b);
  }
}
export function createCompareDateTime(type) {
  var startDay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  switch (type) {
    case 'year':
      return compareYear;

    case 'month':
      return compareMonth;

    case 'date':
      return compareDate;

    case 'hours':
      return compareHours;

    case 'minutes':
      return compareMinutes;

    case 'seconds':
      return compareSeconds;

    case 'day':
      return createCompareDayOfWeek(startDay);

    case 'week':
      return createCompareWeekOfYear(startDay);

    default:
      return compareTime;
  }
}